import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import { auth, guest, SignIn, notVerified } from "../router/middlewares";
import Api from "../utils/api";
var routes = [{
  path: '*',
  component: function component() {
    return import('layouts/LoginLayout.vue');
  },
  children: [{
    name: 'login',
    path: '/login',
    component: function component() {
      return import('pages/Login');
    },
    beforeEnter: guest
  }, {
    name: 'register',
    path: '/register',
    component: function component() {
      return import('pages/SetPassword');
    },
    beforeEnter: guest
  }, {
    name: 'forgot-password',
    path: 'forgot-password',
    component: function component() {
      return import('pages/Password');
    },
    beforeEnter: guest
  }, {
    name: 'set-password',
    path: '/set-password/:token',
    component: function component() {
      return import('pages/SetPassword');
    },
    beforeEnter: guest
  }, {
    name: 'reset',
    path: 'reset',
    component: function component() {
      return import('pages/ContinueToLogin');
    },
    beforeEnter: guest
  }, {
    name: 'registering',
    path: 'registering/:token',
    component: function component() {
      return import('pages/ContinueToLogin');
    },
    beforeEnter: guest
  }, {
    name: 'verify',
    path: 'verify',
    component: function component() {
      return import('pages/Verify');
    },
    beforeEnter: notVerified
  }, {
    name: 'email-verified',
    path: 'email-verified/:token',
    component: function component() {
      return import('pages/EmailVerified');
    },
    beforeEnter: function beforeEnter(to, from, next) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return Api().get('api/verified-user/' + to.params.token);
            case 1:
              _this.Store.dispatch('users/destroyCurrentUser');
              _this.Store.dispatch('users/getCurrentUser');
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              next('/');
            case 3:
              next();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }))();
    }
  }, {
    name: 'sign-in',
    path: 'sign-in/:token',
    component: function component() {
      return import('pages/Login');
    },
    beforeEnter: SignIn
  }]
}, {
  path: '/',
  component: function component() {
    return import('layouts/MyLayout.vue');
  },
  children: [{
    name: 'my-profile',
    path: '/my-profile',
    component: function component() {
      return import('pages/Customer');
    },
    beforeEnter: auth
  }, {
    name: 'loans',
    path: '/loans',
    component: function component() {
      return import('pages/Loans');
    },
    beforeEnter: auth
  }, {
    name: 'applications',
    path: '/applications',
    component: function component() {
      return import('pages/Applications');
    },
    beforeEnter: auth
  }, {
    name: 'cards',
    path: '/cards',
    component: function component() {
      return import('pages/CreditCards');
    },
    beforeEnter: auth
  }, {
    name: 'dashboard',
    path: '/',
    component: function component() {
      return import('pages/Dashboard');
    },
    beforeEnter: auth
  }, {
    name: 'transactions',
    path: '/transactions',
    component: function component() {
      return import('pages/Transactions');
    },
    beforeEnter: auth
  }]
}, {
  path: '/',
  component: function component() {
    return import('layouts/EmptyLayout.vue');
  },
  children: [{
    name: 'loan-agreement',
    path: '/loan-agreement/:loanRef',
    component: function component() {
      return import('pages/LoanAgreement');
    },
    beforeEnter: auth
  }]
}];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    name: '404',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}
export default routes;